import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDisbursementApplications } from "src/apis/controllers/disbursements";
import { useLoading } from "src/hooks/useLoading";

const DisbursementApplicationsGrid = ({ disbursementApplications }) => {
  const navigate = useNavigate();

  const handleOpenApplication = (id) => {
    navigate(`/disbursement-application/${id}`);
  };

  return (
    <div className="card">
      <div className="card-header">
        <h4>
          <b>Οι Αιτήσεις Εκταμίευσής μου</b>
        </h4>
      </div>
      <div className="card-body">
        {disbursementApplications?.length > 0}
        <table className="bordered-table-disbursement-applications">
          <thead>
            <tr>
              <th>#</th>
              <th>A/A Υποβολής</th>
              <th>Ημερομηνία</th>
              <th>Τύπος</th>
              <th>Χρηματοδότηση</th>
              <th>Παράρτημα</th>
              <th>Συνολικός Π/Υ</th>
              <th>Ποσό Εκταμίευσής</th>
              <th>Καταστάση</th>
              <th>Ενέργειες</th>
            </tr>
          </thead>

          {disbursementApplications?.length > 0 ? (
            <tbody>
              {disbursementApplications?.map((application) => {
                return (
                  <tr key={application?.id}>
                    <td>{application?.position}</td>
                    <td>{application?.protocolNumber}</td>
                    <td>
                      {application?.submittedAt ?? application?.createdAt}
                    </td>
                    <td>{application?.type}</td>
                    <td>{application?.applicationIdentifier}</td>
                    <td>{application?.branch}</td>
                    <td>{application?.budget}</td>
                    <td>{application?.installment}</td>
                    <td>{application?.status}</td>
                    <td>
                      {application?.canEdit ? (
                        <div className="action-buttons">
                          <button
                            onClick={() =>
                              handleOpenApplication(application?.id)
                            }
                            className="btn btn-edit"
                          >
                            <EditIcon />
                          </button>
                        </div>
                      ) : (
                        <div className="action-buttons">
                          <button
                            onClick={() =>
                              handleOpenApplication(application?.id)
                            }
                            className="btn btn-view"
                          >
                            <VisibilityIcon />
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tr>
              <td
                colspan="10"
                align="center"
                style={{ border: "none", padding: 20 }}
              >
                <h3 style={{ fontSize: "1.25em" }}> Δεν βρέθηκαν αιτήσεις.</h3>
              </td>
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default DisbursementApplicationsGrid;
